import React, { useState, useEffect } from "react";
import { Card, Button, Form, InputNumber, Spin, message, Row, Col, Divider, Switch } from "antd";
import DownloadSettingsService from "../../services/DownloadSettings"; // adjust path if needed

const DownloadSettings = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Values
  const [maxGuestDownloadsPerDay, setMaxGuestDownloadsPerDay] = useState(0);
  const [maxLoggedInDownloadsPerDay, setMaxLoggedInDownloadsPerDay] = useState(0); // 0 => unlimited
  const [reminderEmailInterval, setReminderEmailInterval] = useState(0); // in minutes


  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 10 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 14 } },
  };

  useEffect(() => {
    getInitialData();
   
  }, []);

  const getInitialData = async () => {
    setLoading(true);
    try {
      const res = await DownloadSettingsService.getDownloadSettings();
      
      // Expected response shape: { status: 200, data: { maxGuestDownloadsPerDay: 5, maxLoggedInDownloadsPerDay: 0, ... } }
      if (res) {
        setMaxGuestDownloadsPerDay(res.maxGuestDownloadsPerDay)
        setMaxLoggedInDownloadsPerDay(res.maxLoggedInDownloadsPerDay);
        setReminderEmailInterval(res.reminderEmailIntervalHours);
      } 
    } catch (err) {
      console.error("Failed to fetch download settings", err);
      message.error("Unable to load download settings.");
    } finally {
      setLoading(false);
    }
  };


  const validateAndSave = async () => {
    // Validate
    if (maxGuestDownloadsPerDay === undefined || maxGuestDownloadsPerDay === null || isNaN(maxGuestDownloadsPerDay)) {
      return message.error("Please set a valid guest downloads limit (0 or greater).");
    }
    if (maxGuestDownloadsPerDay < 0 || maxLoggedInDownloadsPerDay < 0) {
      return message.error("Limits cannot be negative.");
    }

    setSaving(true);
    try {
      const payload = {
        maxGuestDownloadsPerDay: Number(maxGuestDownloadsPerDay),
        // store 0 to mean unlimited
        maxLoggedInDownloadsPerDay: Number(maxLoggedInDownloadsPerDay),
        reminderEmailIntervalHours: Number(reminderEmailInterval),
      };

      const res = await DownloadSettingsService.updateDownloadSettings(payload);

      // Success feedback (handles several possible return shapes)
      if (res && (res.status === 200 || (res.data && res.data._id))) {
        message.success("Download settings updated successfully.");
        // refresh to reflect server changes (optional)
        await getInitialData();
      } else {
        console.warn("Unexpected response from updateDownloadSettings:", res);
        message.success("Download settings updated.");
        await getInitialData();
      }
    } catch (err) {
      console.error("Failed to update download settings", err);
      const errMsg = err?.response?.data?.error || err?.message || "Unable to update download settings.";
      message.error(errMsg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Download Settings</h1>
                <div style={{ color: "#888", marginTop: 6 }}>
                  Control how many sheets users can download in a day.
                </div>
              </div>
            </div>

            <Divider />

            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  <Form>
                    <Row gutter={24}>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          {...formItemLayout}
                          labelAlign="left"
                          label={<span><span style={{ color: "red" }}>*</span>Max Guest Downloads / day</span>}
                        >
                          <InputNumber
                            min={0}
                            style={{ width: "100%" }}
                            value={maxGuestDownloadsPerDay}
                            onChange={(val) => setMaxGuestDownloadsPerDay(val === null ? 0 : val)}
                            placeholder="Number of downloads for guests (0 = disable downloads)"
                          />
                       
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          {...formItemLayout}
                          labelAlign="left"
                          label={<span><span style={{ color: "red" }}>*</span>Max Logged-in Downloads / day</span>}
                        >
                          <InputNumber
                            min={0}
                            style={{ width: "60%", marginRight: 12 }}
                            value={maxLoggedInDownloadsPerDay}
                            onChange={(val) => {setMaxLoggedInDownloadsPerDay(val === null ? 0 : val); }}
                            placeholder="Number of downloads for logged-in users"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          {...formItemLayout}
                          labelAlign="left"
                          label={<span>Reminder Email Interval (Hours)</span>}
                        >
                          <InputNumber
                            min={0}
                            style={{ width: "100%" }}
                            value={reminderEmailInterval}
                            onChange={(val) => setReminderEmailInterval(val === null ? 0 : val)}
                            placeholder="Interval for reminder emails"
                          />
                        </Form.Item>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </Card>

          <div className="ant-row gx-m-0 btn-right" style={{ marginTop: 16 }}>
            <Button
              type="primary"
              className="color-white"
              loading={saving}
              onClick={validateAndSave}
            >
              Save
            </Button>
           
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default DownloadSettings;
